var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#757575;stroke:#fff;stroke-width:.4px}.cls-2{fill:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_935",
    "data-name": "Grupo 935",
    transform: "translate(-19.5 -936.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_exit_to_app_24px",
    d: "M11.154 17.478l1.621 1.622 5.75-5.75-5.75-5.75-1.621 1.621L14.12 12.2H3v2.3h11.12zM21.4 3H5.3A2.3 2.3 0 0 0 3 5.3v4.6h2.3V5.3h16.1v16.1H5.3v-4.6H3v4.6a2.3 2.3 0 0 0 2.3 2.3h16.1a2.307 2.307 0 0 0 2.3-2.3V5.3A2.307 2.307 0 0 0 21.4 3z",
    className: "cls-1",
    transform: "translate(17.65 934.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_854",
    d: "M0 0h23v23H0z",
    className: "cls-2",
    "data-name": "Rect\\xE1ngulo 854",
    transform: "translate(19.5 936.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.cd0970819d070689cdf57ba7178e92f3.svg";
export { ForwardRef as ReactComponent };